import { useMsal } from "@azure/msal-react";
import { acquireToken } from "./acquireToken";

// ID-Token des angemeldeten Kontos für das eigene Statistik-Backend. Das Backend prüft
// Signatur, Tenant und App-ID und nimmt Name/E-Mail ausschließlich aus diesem Token.
export function useIdToken() {
  const { instance, accounts } = useMsal();

  return async function getIdToken(): Promise<string> {
    const account = accounts[0] ?? instance.getActiveAccount();
    if (!account) throw new Error("Kein angemeldeter Microsoft-365-Account");
    let result = await acquireToken(instance, account);
    // Läuft das gecachte ID-Token in den nächsten 5 Minuten ab, frisch holen.
    if (expiresWithin(result.idToken, 300)) result = await acquireToken(instance, account, true);
    return result.idToken;
  };
}

function expiresWithin(jwt: string, seconds: number): boolean {
  try {
    const part = jwt.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const { exp } = JSON.parse(atob(part)) as { exp?: number };
    return !exp || exp * 1000 - Date.now() < seconds * 1000;
  } catch {
    return true;
  }
}
